import {Button,Card,Col,ConfigProvider,Form,Input,InputNumber,message,Modal,notification,Row,Select,Spin, Typography} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { ElectricalSubgroupGrid } from "./ElectricalSubgroupGrid";
const { Title } = Typography;



const { Option } = Select;

const ElectricalSubGroup = () => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode; 
  const [refetch, setRefetch] = useState(true);
  const [loading, setLoading] = useState(false); 
  const [open, setOpen] = useState(false);  
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [row, setRow] = useState([]);
  const [group, setGroup] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (value, option) => {
    console.log(value, option.key);
    setSelectedValue(option.key);
  };

  const getSubGroup = () => {
    console.log(selectedValue);
    const url = `${APIConstants.ELECTRICAL_SUB_GROUP_DETAILS}?GroupId=${selectedValue}`;
    // const url = `${APIConstants.DEVICE_DETAILS}`;
    console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      // body:formValues
    }).then((res) => {
      console.log(res);
      if (res) {
        setRow(res);
      }
    });
  };

  useEffect(() => {
    getSubGroup();
  }, [selectedValue, refetch]);
  console.log(refetch);

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };

  
  const handleNotification = (msg,type) => {
    message.open({
      content: `${msg}`,
      type:type, 
      // showProgress: true,
      // placement:'top'
    });
  };

  const handleAddPopup = () => {
    console.log("pop open");
    setOpen(true);
    // navigate(`${CONFIGURATION_CONVERTER}/converter-add-popup`);
  };

  useEffect(() => {
    makeRequest({
      type: APIConstants.POST,
      url:`${APIConstants.ELECTRICAL_GROUP_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if(res){
        setGroup(res);
      }
    });
  }, []); 
  console.log(group)
  console.log(selectedValue)
  const color = useSelector((state) => state.ThemeChange);
  console.log(color)

  return (
    <div>
       <h4 className={`text-left text-[20px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>SUB GROUP </h4>
      <Card
        className={`w-full  h-auto dark ${
          !isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"
        } `}
      >
        <div className=" flex justify-between mb-3">
          <Select
            // value={selectedValue}
            onChange={handleChange}
            style={{ width: 200 }}
            labelInValue
            placeholder="Select a group"
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
            className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
          >
            {group.map((i) => (
              <Option key={i.groupID} value={i.department}>
                {i.department}
              </Option>
            ))}
          </Select>

                      <Button
            type= {isdarkMode? "":'primary'}
            onClick={handleAddPopup}
            className=" mb-2"
          >
           Add Sub-Group
          </Button>
        </div>
        <SubGroupPopup
          handleOk={handleOk} 
          handleCancel={handleCancel}
          open={open}
          refetch={refetch}
          setRefetch={setRefetch}
          handleNotification={handleNotification}
        />


        {row?.length > 0 && (
          <div 
          className={`${isdarkMode ? "ag-theme-alpine" : "ag-theme-quartz"}`}
        style={{
          '--ag-header-background-color': color.themeConfig.colorPrimary, 
          '--ag-header-foreground-color': '#fff', 
          height: "80vh", width: "100%", overflowY: "auto" 
        }}>
            {/* <Spin indicator={<Spin size="large" />} spinning={false}> */}
            <ElectricalSubgroupGrid
                row={row}
                refetch={refetch}
                setRefetch={setRefetch}
                handleNotification={handleNotification}
                setSelectedValue={setSelectedValue}
                selectedValue={selectedValue}
              />
            {/* </Spin> */}
          </div>
        )}
      </Card>
    </div>
  );
};

export default ElectricalSubGroup;



const SubGroupPopup = ({
  handleOk,
  handleCancel,
  open,
  loading,
  refetch,
  setRefetch,
  handleNotification,
}) => {
  console.log(open);
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const { makeRequest } = useStoreUpdaterWithAPI();

  const [group, setGroup] = useState([]);


  // State to hold form values
  const [formValues, setFormValues] = useState({});
  const [form] = Form.useForm();

  // Handle form submission
  const onFinish = (values) => {
    // setFormValues(values);
    console.log(values);
    const formData = (values) => {
      return {
        groupID: values.groupID?.key || null, 
        subGroupType: 'Plus' || null, 
        subGroupName: values.subGroupName || null 
      };
    };
    const formValues = formData(values)
    console.log(formValues);
    handleOk();
    insertDevice(formValues);
  };
  // Reset form values when modal is closed
  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  const insertDevice = (formValues) => {
    console.log(formValues);
    const url = `${APIConstants.ELECTRICAL_INSERT_SUB_GROUP}`;
    console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: formValues,
    }).then((res) => {
      console.log(res);
      // setRefetch(!refetch)
      handleNotification("Device added successfully!",'success');
    }).catch((err) => {
      handleNotification("Something went wrong!",'error');

    });
  };

  useEffect(() => {
    makeRequest({
      type: APIConstants.POST,
      url:`${APIConstants.ELECTRICAL_GROUP_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if(res){
        setGroup(res);
      }
    });
  }, []);
  console.log(group)

  const type= [
    { name: 'Plus', value: 'Plus' },
    { name: 'Minus', value: 'Minus' },
  ]
  const color = useSelector((state) => state.ThemeChange);
  console.log(color)

  return (
    <Modal
      open={open}
      // title={<div className={` ${isdarkMode ? "text-white" : "text-black"}`}>Add Sub-Group</div>}
      // title="Add New Converter"
      onOk={handleOk}
      onCancel={handleCancel}
      // width={800}
      footer={null}
      // className={` custom-modal ${isdarkMode ? "dark-modal" : "light-modal"}`}
      className={`custom-modal  ${isdarkMode ? " group-custom-modal-dark  group-custom-modal-header group-labels group-input group-select-input-background " : "whitemode"} `}
    >
         <div className="modal-header mb-3 px-4 py-3  rounded-t-lg"
         style={{ backgroundColor: color.themeConfig.colorPrimary }}>
        <Title level={4} style={{ margin: 0, color: "white" }}>
          Add Sub Group
        </Title>
      </div>
      <div className="modal-body px-4 pb-3">
      <Form
        name="Group-add-form"
        className="font-bold"
        layout="horizontal"
        style={{
          maxWidth: 600,
        }}
        labelCol={{
          span: 8,
          offset: 0,
        }}
        labelAlign="left"
        onFinish={onFinish}
      >
        <Form.Item
          label="Group Name"
          name="groupID"
          rules={[
            {
              required: true,
              message: "Please select a group!",
            },
          ]}
        >
        <Select
            // value={selectedValue}
            // onChange={handleChange}
            // style={{ width: 200 }}
            labelInValue
            placeholder="Select a group"
            // dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
            // className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
            className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
          >
            {group.map((i) => (
              <Option key={i.groupID} value={i.department}>
                {i.department}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Sub-Group Name"
          name="subGroupName"
          rules={[
            {
              required: true,
              message: "Please input Group ID!",
            },
          ]}
        >
          <Input
            style={{
              width: "100%",
            }}
          />
        </Form.Item>

        {/* <Form.Item
          label="Sub-Group Type"
          name="subGroupType"
          rules={[
            {
              required: true,
              message: "Please select a sub-group type!",
            },
          ]}
        >
        <Select
            // value={selectedValue}
            // onChange={handleChange}
            // style={{ width: 200 }}
            labelInValue
            placeholder="Select a group"
            // dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
            // className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
          >
            {type.map((i) => (
              <Option key={i.name} value={i.value}>
                {i.value}
              </Option>
            ))}
          </Select>
        </Form.Item> */}

        <Form.Item
          wrapperCol={{
            offset: 16,
            span: 16,
          }}
        >
          <Button key="back" className="mr-3" onClick={handleCancel}>
            Cancel
          </Button>
          
          <Button htmlType="submit" type="primary" loading={loading}>
            Save
          </Button>
        </Form.Item>
      </Form>
      </div>
    </Modal>
  );
};